import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'

import Main from './pages/Main'
import Catalog from './pages/Catalog'
import About from './pages/AboutInfo'
import Cart from './pages/Cart'
import Search from './pages/Search'
import AdminLogin from './admin/pages/AdminLogin'
import AdminDashboard from './admin/pages/AdminDashboard'
import ProtectedAdminRoute from './admin/components/ProtectedAdminRoute'

function App() {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<Main />} />
        <Route path='/catalog' element={<Catalog />} />
        <Route path='/about' element={<About />} />
        <Route path='/cart' element={<Cart />} />
        <Route path='/search' element={<Search />} />
        <Route path='/admin' element={<AdminLogin />} />
        <Route
          path='/admin/dashboard'
          element={
            <ProtectedAdminRoute>
              <AdminDashboard />
            </ProtectedAdminRoute>
          }
        />
      </Routes>   
    </Router>
  )
}

export default App
